import React from 'react';
import { IconButton, SaveIcon, CloseIcon } from 'view/pages/Profile/Profile.styles';

interface IProps {
    onSave: () => Promise<void>;
    onClose: () => void;
}

const ActionButtonGroup: React.FunctionComponent<IProps> = ({ onSave, onClose }) =>
{
    return (
        <>
            <IconButton saveBtn onClick={onSave}>
                <SaveIcon />
            </IconButton>
            <IconButton onClick={onClose}>
                <CloseIcon />
            </IconButton>
        </>
    );
};

export default ActionButtonGroup;
